import DruhPrijmuSelect from './DruhPrijmuSelect';

export default DruhPrijmuSelect;
